import apiClient from '../config/api';
import { buildApiEndpoint } from '../utils/apiHelpers';

export const getInspirations = async (params = {}) => {
  try {
    const endpoint = buildApiEndpoint('inspirations');
    const response = await apiClient.get(endpoint, {
      params: {
        service_category_id: params.service_category_id || undefined,
        service_id: params.service_id || undefined,
        skip: params.skip || 0,
        limit: params.limit || 20,
        sort_by_category: params.sort_by_category ?? true,
        sort_by_service: params.sort_by_service ?? true,
        sort_by_display_order: params.sort_by_display_order ?? true,
        category_order: params.category_order || 'asc',
        service_order: params.service_order || 'asc',
        display_order: params.display_order || 'asc',
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching inspirations:', error);
    throw error;
  }
};